import {storeToRefs} from 'pinia';
import {computed, Ref} from 'vue';
import {TourDefinition, useOnboardingExistingUser} from '..';
import {useExpandedTabs} from '../..';
import {useUser} from '../../user';

export function useProductTour(componentIndex: Ref<number>) {
    const userStore = useUser();
    const {expandTab} = useExpandedTabs();

    const onboardingExistingUserStore = useOnboardingExistingUser();
    const {selectedOnboardingTourStepIndex, activeTours} = storeToRefs(onboardingExistingUserStore);

    const hasPreviousActiveTourStep = computed<boolean>(() => {
        return componentIndex.value > 0;
    });

    const hasNextActiveTourStep = computed<boolean>(() => {
        return componentIndex.value + 1 < activeTours.value.length;
    });

    const getPreviousActiveTourStep = computed<TourDefinition | undefined>(() => {
        return activeTours.value[componentIndex.value - 1];
    });

    const getNextActiveTourStep = computed<TourDefinition | undefined>(() => {
        return activeTours.value[componentIndex.value + 1];
    });

    const previousTourStepProductTourId = computed(() => `navbarTour${getPreviousActiveTourStep.value?.navTabId}`);
    const previousTourStepTarget = computed(() => `[data-testid='${getPreviousActiveTourStep.value?.navTabId}']`);

    const activeTourStepProductTourId = computed(() => `navbarTour${getNextActiveTourStep.value?.navTabId}`);
    const activeTourStepTarget = computed(() => `[data-testid='${getNextActiveTourStep.value?.navTabId}']`);

    function setOnboardingTourIndex(index: number) {
        if (index >= 0 && index + 1 <= activeTours.value.length) {
            selectedOnboardingTourStepIndex.value = index;
            expandTab(onboardingExistingUserStore.selectedOnboardingTourStep.navTabId);
        }
    }

    async function prepareAndGoToNextStep() {
        if (hasNextActiveTourStep.value) {
            selectedOnboardingTourStepIndex.value++;
            expandTab(onboardingExistingUserStore.selectedOnboardingTourStep.navTabId);
        } else {
            userStore.user!.options.onboarded = true;
        }
    }

    function prepareAndGoToPreviousStep() {
        if (hasPreviousActiveTourStep.value) {
            selectedOnboardingTourStepIndex.value--;
            expandTab(onboardingExistingUserStore.selectedOnboardingTourStep.navTabId);
        }
    }

    return {
        hasNextActiveTourStep,
        getNextActiveTourStep,
        hasPreviousActiveTourStep,
        prepareAndGoToNextStep,
        prepareAndGoToPreviousStep,
        setOnboardingTourIndex,
        activeTourStepProductTourId,
        activeTourStepTarget,
        previousTourStepProductTourId,
        previousTourStepTarget,
    };
}
